<script>
    import CustomersCollection from '../components/customers/CustomersCollection.vue';

    export default {
      components: { CustomersCollection },
    };
</script>